import { MantineColor } from "@mantine/core";
import { StatusBadgeHelp } from "@dehub/theme";
import { useTranslation } from "react-i18next";
import type { AlertStatus } from "../../apis/return-prevention-alert";
import { DotPill, Tone } from "../delivery/atoms";

/** Kept for callers that colour charts by status. */
export const STATUS_COLOR: Record<AlertStatus, MantineColor> = {
  ACTIVE      : "orange",
  ACKNOWLEDGED: "blue",
  MUTED       : "gray",
  RESOLVED    : "green",
};

export const STATUS_VARIANT: Record<AlertStatus, "filled" | "light"> = {
  ACTIVE      : "filled",
  ACKNOWLEDGED: "light",
  MUTED       : "light",
  RESOLVED    : "light",
};

/** Dot tone (canvas Ord_Prevention «● Идэвхтэй»): waiting = amber, seen = blue, closed = green, muted = grey. */
export const STATUS_TONE: Record<AlertStatus, Tone> = {
  ACTIVE      : "amber",
  ACKNOWLEDGED: "blue",
  MUTED       : "grey",
  RESOLVED    : "green",
};

interface Props {
  status: AlertStatus;
  /** Kept for call-site compatibility; the dot pill has one size. */
  size?: "xs" | "sm" | "md" | "lg";
  /** Hover popover from `order.alert-status` (@dehub/help R5). */
  help?: boolean;
}

export function AlertStatusBadge({ status, help }: Props) {
  const { t } = useTranslation("returns");
  const label = t(`alertStatus.${status}`, { defaultValue: "-" });
  const pill = <DotPill tone={STATUS_TONE[status] ?? "grey"}>{label}</DotPill>;
  return help ? <StatusBadgeHelp helpNs="order.alert-status" code={status} name={label}>{pill}</StatusBadgeHelp> : pill;
}
